/* Collection / search filters — sort, auto-submit, mobile drawer */
(function () {
  'use strict';

  function init() {
    var toolbar = document.querySelector('[data-collection-toolbar]');
    if (!toolbar) return;

    /* Sort */
    var sort = toolbar.querySelector('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.toString();
      });
    }

    /* Filter auto-submit (sidebar and/or toolbar forms) */
    var filterForms = document.querySelectorAll('[data-filter-form]');
    filterForms.forEach(function (filterForm) {
      filterForm.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], input[type="radio"]')) {
          filterForm.submit();
        }
      });
      /* Debounced text/number inputs (price range) */
      var debounce = null;
      filterForm.addEventListener('input', function (e) {
        if (e.target.matches('input[type="number"], input[type="text"]')) {
          clearTimeout(debounce);
          debounce = setTimeout(function () { filterForm.submit(); }, 800);
        }
      });
    });

    /* Mobile filters drawer */
    var toggle = toolbar.querySelector('[data-filters-toggle]');
    var filters = document.querySelector('[data-filters]');
    if (toggle && filters) {
      toggle.addEventListener('click', function () {
        var open = filters.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
